import React ,{ useEffect} from 'react'
import { resetCameraImage, selectCameraImage } from './features/cameraSlice';
import "./Preview.css";
import CloseIcon from '@material-ui/icons/Close';
import {useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {useDispatch} from "react-redux";
import SendIcon from '@material-ui/icons/Send';

import TextFieldsIcon from '@material-ui/icons/TextFields';
import CreateIcon from '@material-ui/icons/Create';
import NoteIcon from '@material-ui/icons/Note';
import MusicNoteIcon from '@material-ui/icons/MusicNote';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import CropIcon from '@material-ui/icons/Crop';
import TimerIcon from '@material-ui/icons/Timer';
import {v4 as uuid} from "uuid";
import { db, storage } from './firebase';
import firebase from "firebase";
import { selectUser } from './features/appSlice';


 function Preview() {
    const cameraImage=useSelector(selectCameraImage);
    const history = useHistory();
    const user = useSelector(selectUser);
    console.log(cameraImage);
   const dispatch = useDispatch();
    useEffect(() => {
        if(!cameraImage)
    {
        history.replace("/");
    }
    }, [cameraImage,history])
   
   
    const closePreview=()=>{
dispatch(resetCameraImage());
//history.replace("/");
    }
    const sendPost =()=>{
const id = uuid();
const uploadTask = storage.ref(`posts/${id}`).put(cameraImage);        
uploadTask.on("state_changed",null,(error)=>{
   //error function 
    console.log(error);
},
()=>{
//complete function 
storage.ref('posts').child(id).getDownloadURL().then((url)=>{
    db.collection('posts').add({
        imageUrl:cameraImage,
        username: user.username,
        read:false,
        profilePic:user.profilePic,
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    })
    history.replace("/chats");

})
})


}
    


    return (
        <div className="preview">
            <CloseIcon onClick={closePreview} className="preview__close"/>
           <div className="preview__toolbarRight">
<TextFieldsIcon/>
<CreateIcon/>
<NoteIcon/>
<MusicNoteIcon/>
<AttachFileIcon/>
<CropIcon/>
<TimerIcon/>
           </div>
            <img src ={cameraImage} alt="" /> 
       <div onClick={sendPost} className="preview__footer">
           <h2>
               Send Now
           </h2>
           <SendIcon fontSize="small" className="preview__sendIcon"/>
       </div>
        </div>
    )
}
export default Preview;